import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function ShieldLock({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M14.3136 11.125V9.77501C14.3136 8.93201 13.6236 8.24501 12.7836 8.24501C11.9406 8.24501 11.2536 8.92501 11.2536 9.76501V11.105M14.5366 11.12H11.0366C10.4766 11.12 10.0366 11.56 10.0366 12.12V14.24C10.0366 14.79 10.4766 15.24 11.0366 15.24H14.5366C15.0866 15.24 15.5366 14.79 15.5366 14.24V12.11C15.5366 11.55 15.0866 11.11 14.5366 11.11V11.12ZM20.7866 11.24C20.7866 15.608 17.6296 19.7 13.3066 20.92C12.9666 21.01 12.6046 21.01 12.2666 20.92C7.93662 19.69 4.78662 15.6 4.78662 11.23V7.20001C4.78662 6.38001 5.27662 5.65001 6.02662 5.34901L10.8866 3.35901C12.0966 2.85901 13.4606 2.85901 14.6666 3.35901L19.5266 5.34901C20.2766 5.64901 20.7666 6.37901 20.7666 7.20001V11.228L20.7866 11.24Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default ShieldLock;